type State = {
	grupoConcessionaria: string;
	tagAtivo: string;
	logotipo: any;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number }
	| { type: 'REPLACE_STATE'; payload: State };

export const newGroupFormInitialState: State = {
	grupoConcessionaria: '',
	tagAtivo: '',
	logotipo:'',
};

export const newGroupFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				[action.field]: action.payload,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		case 'REPLACE_STATE':
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};
